const generateBreadcrumbs = (model: string) => {
  const basePathObject = { basePathText: 'Healthcare Insights', basePathUrl: '/healthcare-insights' };
  switch (model) {
    case 'template-article':
      return { ...basePathObject, ...{ secondPathText: 'Articles', queryParam: 'article' } };
    case 'template-claims-lesson':
      return { ...basePathObject, ...{ secondPathText: 'Case Studies', queryParam: 'case-study' } };
    case 'template-course':
      return { ...basePathObject, ...{ secondPathText: 'Courses', queryParam: 'course' } };
    case 'template-podcast':
      return { ...basePathObject, ...{ secondPathText: 'Podcast', queryParam: 'podcast' } };
    case 'template-risk-assessment':
      return { ...basePathObject, ...{ secondPathText: 'Risk Assessments', queryParam: 'risk-assessment' } };
    case 'template-risk-report':
      return { ...basePathObject, ...{ secondPathText: 'Risk Reports', queryParam: 'risk-report' } };
    case 'template-toolkit':
      return { ...basePathObject, ...{ secondPathText: 'Toolkits', queryParam: 'toolkit' } };
    case 'template-video':
      return { ...basePathObject, ...{ secondPathText: 'Videos', queryParam: 'video' } };
    default:
      return null;
  }
};

export default generateBreadcrumbs;
